import { render, staticRenderFns } from "./newGlobalSearch.vue?vue&type=template&id=26937c61&scoped=true&"
import script from "./newGlobalSearch.vue?vue&type=script&lang=js&"
export * from "./newGlobalSearch.vue?vue&type=script&lang=js&"
import style0 from "./newGlobalSearch.vue?vue&type=style&index=0&id=26937c61&prod&lang=scss&"
import style1 from "./newGlobalSearch.vue?vue&type=style&index=1&id=26937c61&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26937c61",
  null
  
)

export default component.exports